const dev = {
  url: {
    API_URL: "http://conduit.9ijakids.com",
  },
};

export const Config = dev;
